import template from "./your_farms.html";
import en from "./en.translation.json";
import es from "./es.translation.json";

export default {
    bindings: { growers: "<" },
    template: template,
    name: "yourGrowers",
    translations: { en, es },
};
